export const BRAND_NAME = 'BetBazaar';
// Note: It is the main site url. Ex - quickexch.com, etc.
export const BRAND_DOMAIN = 'diamond-exc.com';
// Note: It is the hostname. Ex - pay-diamond.quickexch.com, diamond.quickexch.com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'diamond-exc.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const OPERATORID = 'HypexDemo';
export const BACKEND_DOMAIN = 'cue88.com';